import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles.css';

/**
 * Ask the browser to keep our IndexedDB from being evicted under storage
 * pressure. The outbox holds the one thing on this device that cannot be
 * re-fetched from the server — a check-off or an item added in a shop with no
 * signal — so an eviction is data lost, not merely a slow reload.
 *
 * Best-effort and fire-and-forget: an installed PWA is usually granted this
 * automatically, some browsers (notably iOS Safari) do not honour it, and none
 * of that is worth delaying the first paint for. `persisted()` first so a
 * browser that would prompt is not asked again once it has answered.
 */
async function requestPersistentStorage() {
  try {
    if (!navigator.storage?.persist) return;
    if (await navigator.storage.persisted()) return;
    await navigator.storage.persist();
  } catch {
    /* best effort — durability is a bonus here, not a precondition */
  }
}
void requestPersistentStorage();

const root = document.getElementById('root');
if (!root) throw new Error('no #root element');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
